import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { delay: { type: Number, default: 300 } }

    connect() { this.timer = null }

    queue() {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => this.submit(), this.delayValue)
    }

    submit() {
        // Find the nearest form and submit it (Turbo will target the frame)
        const form = this.element.closest("form")
        if (form) form.requestSubmit()
    }
}